var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-box-container"},[(_vm.isShowInput)?_c('div',[_c('b-form-input',{staticClass:"input-medium",attrs:{"autocomplete":"off"},on:{"input":function($event){return _vm.onChangeInput()}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }